import React from 'react';

export interface IMarketplaceContext {
  lastSoldMap: {
    [tokenAddressID: string]: { salePrice: string; isStarsListing: boolean };
  };
  purchasePriceMap: {
    [tokenAddressID: string]: { listingPrice: string; isStarsListing: boolean };
  };
  notificationEmail: string;
  setNotificationEmail: (e: string) => void;
}

export const MarketPlaceContext: React.Context<IMarketplaceContext> =
  React.createContext({
    lastSoldMap: {},
    purchasePriceMap: {},
    notificationEmail: '',
    setNotificationEmail: (_: string) => {},
  });
